<mat-card appearance="outlined">
  <mat-card-title>Add New Purchase Order</mat-card-title>

  <mat-card-content>
    <form [formGroup]="addPurchaseOrderForm" novalidate>
      <!-- Row 1: PO Number, Order Date, Vendor -->
      <div class="row">
        <div class="col-12 col-md-4">
          <mat-form-field appearance="fill" color="accent">
            <mat-label>Po Number</mat-label>
            <input
              matInput
              type="text"
              formControlName="poNumber"
              maxlength="50"
              autocomplete="off"
              appInputValidator
              [sanitizeScriptTags]="true"
            />
            <mat-error *ngIf="addPurchaseOrderForm.get('poNumber').hasError('required') && addPurchaseOrderForm.get('poNumber').touched">
              Po number is required.
            </mat-error>
            <mat-error *ngIf="addPurchaseOrderForm.get('poNumber').hasError('maxlength')">
              Cannot exceed 50 characters.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-4">
          <mat-form-field appearance="fill" color="accent">
            <mat-label>Order Date</mat-label>
            <input
              matInput
              [matDatepicker]="picker1"
              formControlName="orderDate"
              [max]="today"
              readonly
            />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error *ngIf="addPurchaseOrderForm.get('orderDate').hasError('required')">
              Order Date is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-4">
          <mat-form-field appearance="fill" color="accent" *ngIf="vendorOptions.length > 0">
            <mat-label>Vendor</mat-label>
            <mat-select formControlName="vendorCode" [disabled]="vendorOptions.length === 0">
              <mat-option value="">Select an option</mat-option>
              <mat-option *ngFor="let v of vendorOptions" [value]="v.vendorCode">
                {{ v.vendorCode }} | {{ v.vendorName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="addPurchaseOrderForm.get('vendorCode').hasError('required') && addPurchaseOrderForm.get('vendorCode').touched">
              Vendor Code is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Row 2: Description, Address -->
      <div class="row">
        <div class="col-12 col-md-3">
          <mat-form-field appearance="fill" color="accent">
            <mat-label>Description</mat-label>
            <input
              matInput
              type="text"
              formControlName="description"
              maxlength="100"
              appInputValidator
              [sanitizeScriptTags]="true"
              [hasAtLeastOneAlphabet]="true"
            />
            <mat-error *ngIf="addPurchaseOrderForm.get('description').hasError('required')">
              Description is required.
            </mat-error>
            <mat-error *ngIf="addPurchaseOrderForm.get('description').hasError('maxlength')">
              Max 100 characters.
            </mat-error>
            <mat-error *ngIf="addPurchaseOrderForm.get('description').hasError('noAlphabet')">
              Must contain at least one alphabet.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-9">
          <mat-form-field appearance="fill" color="accent">
            <mat-label>Address</mat-label>
            <input
              matInput
              type="text"
              formControlName="address"
              maxlength="250"
              appInputValidator
              [sanitizeScriptTags]="true"
              [hasAtLeastOneAlphabet]="true"
            />
            <mat-error *ngIf="addPurchaseOrderForm.get('address').hasError('required')">
              Address is required.
            </mat-error>
            <mat-error *ngIf="addPurchaseOrderForm.get('address').hasError('maxlength')">
              Max 250 characters.
            </mat-error>
            <mat-error *ngIf="addPurchaseOrderForm.get('address').hasError('noAlphabet')">
              Must contain at least one alphabet.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Row 3: Purchase Order Details -->
      <div class="row">
        <div class="col-12">
          <mat-accordion formArrayName="PurchaseOrderDetails">
            <mat-expansion-panel
              *ngFor="let item of addPurchaseOrderForm.get('PurchaseOrderDetails')['controls']; let i = index; first as isFirst"
              [formGroupName]="i"
              [expanded]="isFirst"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>apps</mat-icon> #{{ i + 1 }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="row">
                <div class="col-12 col-md-4">
                  <mat-form-field appearance="fill" color="accent">
                    <mat-label>Products</mat-label>
                    <mat-select formControlName="productId" (selectionChange)="onProductSelectionchange($event)">
                      <mat-option value="">Select</mat-option>
                      <mat-option *ngFor="let p of productOptions" [value]="p.productId">
                        {{ p.productName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('productId').hasError('required')">
                      Product is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-form-field appearance="fill" color="accent">
                    <mat-label>Product Categories</mat-label>
                    <mat-select formControlName="categoryId" (selectionChange)="onCategorySelectionchange($event)">
                      <mat-option [value]="null">Select</mat-option>
                      <mat-option *ngFor="let c of categoryOptions" [value]="c.categoryId">
                        {{ c.productCategoryName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('categoryId').hasError('required')">
                      Category is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-4">
                  <mat-form-field appearance="fill" color="accent">
                    <mat-label>Sub Categories</mat-label>
                    <mat-select formControlName="subcategoryId">
                      <mat-option [value]="null">Select</mat-option>
                      <mat-option *ngFor="let s of subCategoryOptions" [value]="s.subCategoryId">
                        {{ s.subCategoryName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('subcategoryId').hasError('required')">
                      Subcategory is required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-3">
                  <mat-form-field appearance="fill" color="accent">
                    <mat-label>Brand</mat-label>
                    <mat-select formControlName="brandId">
                      <mat-option value="">Select</mat-option>
                      <mat-option *ngFor="let b of brandOptions" [value]="b.brandId">
                        {{ b.brandName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('brandId').hasError('required')">
                      Brand is required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-2">
                  <mat-form-field appearance="fill" color="accent">
                    <mat-label>Order Qty</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="orderQuantity"
                      min="1"
                      max="90000"
                      appInputValidator
                      [allowNumbersOnly]="true"
                    />
                    <mat-error *ngIf="item.get('orderQuantity').hasError('required')">
                      Required.
                    </mat-error>
                    <mat-error *ngIf="item.get('orderQuantity').hasError('min')">
                      Min 1.
                    </mat-error>
                    <mat-error *ngIf="item.get('orderQuantity').hasError('max')">
                      Max 90000.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-2">
                  <mat-form-field appearance="fill" color="accent">
                    <mat-label>UOM</mat-label>
                    <mat-select formControlName="measuringUnitId">
                      <mat-option [value]="null">Select</mat-option>
                      <mat-option *ngFor="let u of measuringOptions" [value]="u.measuringUnitId">
                        {{ u.unitName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="item.get('measuringUnitId').hasError('required')">
                      Required.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-2">
                  <mat-form-field appearance="fill" color="accent">
                    <mat-label>Warranty (Months)</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="warrantyInMonths"
                      min="0"
                      max="60"
                      appInputValidator
                      [allowNumbersOnly]="true"
                    />
                    <mat-error *ngIf="item.get('warrantyInMonths').hasError('required')">
                      Required.
                    </mat-error>
                    <mat-error *ngIf="item.get('warrantyInMonths').hasError('min')">
                      Min 0.
                    </mat-error>
                    <mat-error *ngIf="item.get('warrantyInMonths').hasError('max')">
                      Max 60.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-2">
                  <mat-form-field appearance="fill" color="accent">
                    <mat-label>Unit Price</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="unitPrice"
                      min="0"
                      max="2000000"
                      appInputValidator
                      [allowNumbersOnly]="true"
                    />
                    <mat-error *ngIf="item.get('unitPrice').hasError('required')">
                      Required.
                    </mat-error>
                    <mat-error *ngIf="item.get('unitPrice').hasError('min')">
                      Min 0.
                    </mat-error>
                    <mat-error *ngIf="item.get('unitPrice').hasError('max')">
                      Max 2,000,000.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-12 col-md-1 text-center">
                  <button
                    mat-fab
                    type="button"
                    (click)="onRemoveItem(i)"
                    [disabled]="addPurchaseOrderForm.get('PurchaseOrderDetails').length === 1"
                  >
                    <mat-icon>remove_from_queue</mat-icon>
                  </button>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </form>
  </mat-card-content>

  <!-- Action Buttons -->
  <mat-card-actions align="end">
    <button
      mat-raised-button
      color="primary"
      (click)="savePurchaseOrder()"
      [disabled]="!addPurchaseOrderForm.valid || measuringOptions.length === 0"
      matTooltip="Save Purchase Order"
    >
      <mat-icon>save</mat-icon>
    </button>
    <button
      mat-raised-button
      color="accent"
      (click)="addItem()"
      [disabled]="!addPurchaseOrderForm.valid || !isAdminGroupUser"
      matTooltip="Add More Purchase Details"
    >
      <mat-icon>queue</mat-icon>
    </button>
    <button mat-raised-button color="warn" (click)="close()" matTooltip="Close Form">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
